"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POPUP_CONSTANTS = void 0;
var POPUP_CONSTANTS;
(function (POPUP_CONSTANTS) {
    POPUP_CONSTANTS["SIGN_UP_MODAL"] = "signUp";
    POPUP_CONSTANTS["SIGN_IN_MODAL"] = "signIn";
    POPUP_CONSTANTS["SIGN_IN_BONUS_MODAL"] = "signInBonus";
    POPUP_CONSTANTS["SIGN_IN_BONUS_CONGRATS_MODAL"] = "signInBonusCongrats";
    POPUP_CONSTANTS["SIGN_UP_MODAL_CONGRATS"] = "signUpCongrats";
    POPUP_CONSTANTS["GAME_SEARCH"] = "search";
    POPUP_CONSTANTS["FORGOT_PASS"] = "forgotPass";
    POPUP_CONSTANTS["FORGOT_PASS_PHONE"] = "forgotPassPhone";
    POPUP_CONSTANTS["SET_NEW_PASSWORD"] = "setNewPassword";
    POPUP_CONSTANTS["WELCOME"] = "welcome";
    POPUP_CONSTANTS["DEPOSIT"] = "deposit";
    POPUP_CONSTANTS["PROFILE_MENU"] = "profile";
    POPUP_CONSTANTS["ADD_CURRENCY"] = "add-currency";
    POPUP_CONSTANTS["GAME_INFO_MODAL"] = "game-info-";
    POPUP_CONSTANTS["DEPOSIT_SUCCESS"] = "deposit-success";
    POPUP_CONSTANTS["DEPOSIT_CANCEL"] = "deposit-cancel";
    POPUP_CONSTANTS["DEPOSIT_ERROR"] = "deposit-error";
    POPUP_CONSTANTS["DEPOSIT_PENDING"] = "deposit-pending";
    POPUP_CONSTANTS["WITHDRAWAL_ACCEPTED"] = "withdrawal-accepted";
    POPUP_CONSTANTS["WITHDRAWAL_CHECK"] = "withdrawal-check";
    POPUP_CONSTANTS["SEARCH"] = "search";
    POPUP_CONSTANTS["DAILY_DIGEST"] = "daily-digest";
    POPUP_CONSTANTS["LEVEL_UP"] = "levelUp";
    POPUP_CONSTANTS["CASH_BONUS"] = "cashBonus";
    POPUP_CONSTANTS["DEPOSIT_REACHED"] = "depositReached";
    POPUP_CONSTANTS["COOLING_OFF_ACTIVE"] = "coolingOffActive";
    POPUP_CONSTANTS["PERSONAL_MANAGER"] = "personal-manager";
    POPUP_CONSTANTS["WHEEL"] = "wheel";
    POPUP_CONSTANTS["VIP_WHEEL"] = "vip-wheel";
    POPUP_CONSTANTS["EMAIL_VERIFY"] = "verifyEmail";
    POPUP_CONSTANTS["EMAIL_CONFIRM"] = "confirmEmail";
    POPUP_CONSTANTS["USER_BAlANCE"] = "userBalance";
})(POPUP_CONSTANTS = exports.POPUP_CONSTANTS || (exports.POPUP_CONSTANTS = {}));
